module.exports = __webpack_public_path__ + "img/11.9867318d.webp";